import ButtonTypes, { ButtonSizes, ButtonType } from './ButtonTypes';

export const isStandardIcon = (type: ButtonType) => type === 'icon' || type === 'icon-dark' || type === 'icon-negative';

const largeSizeArray: ButtonType[] = ['icon', 'icon-dark', 'icon-negative'];
const extraLargeSizeArray: ButtonType[] = ['action'];

export const mapIconSizes = (type: ButtonType, size: ButtonSizes) => {
    switch (size) {
        case 'small':
            return 'icon--20';
        case 'large':
            return 'icon--24';
        case 'standard':
        default:
            if (largeSizeArray.includes(type)) {
                return 'icon--24';
            }

            if (extraLargeSizeArray.includes(type)) {
                return 'icon--36';
            }

            return 'icon--22';
    }
};

export const mapButtonTypes = (
    type: ButtonType | ButtonTypes,
    size: ButtonSizes,
): { type: ButtonType; size: ButtonSizes } => {
    switch (type) {
        case ButtonTypes.LINK:
            return { type: 'link', size };
        case ButtonTypes.LARGE_LINK:
        case 'large-link':
            return { type: 'link', size: 'large' };
        case ButtonTypes.ICON:
            return { type: 'icon', size };
        case ButtonTypes.ICON_NEGATIVE:
            return { type: 'icon-dark', size };

        case ButtonTypes.SMALL_ICON:
            return { type: 'icon', size: 'small' };

        case ButtonTypes.ACTION:
            return { type: 'action', size };

        case ButtonTypes.SMALL_POSITIVE:
            return { type: 'positive', size: 'small' };
        case ButtonTypes.SMALL_NEGATIVE:
            return { type: 'negative', size: 'small' };
        case ButtonTypes.LARGE_POSITIVE:
            return { type: 'positive', size: 'large' };
        case ButtonTypes.LARGE_NEGATIVE:
            return { type: 'negative', size: 'large' };
        case ButtonTypes.STANDARD_NEGATIVE:
            return { type: 'negative', size };
        case ButtonTypes.STANDARD_POSITIVE:
            return { type: 'positive', size };

        default:
            return { type, size };
    }
};
